import { useEffect, useRef } from "react";
import { toast } from "sonner";

const useToastFeedback = (ativo, mensagem, tipo) => {
  const lastMessageKey = useRef(null);

  useEffect(() => {
    if (!ativo) {
      lastMessageKey.current = null;
      return;
    }

    if (!mensagem) {
      return;
    }

    const key = `${tipo}-${mensagem}`;

    if (lastMessageKey.current === key) {
      return;
    }

    lastMessageKey.current = key;

    const toastFn = {
      sucesso: toast.success,
      erro: toast.error,
      info: toast.info,
      aviso: toast.warning,
    }[tipo] || toast;

    toastFn(mensagem, {
      duration: tipo === "aviso" ? 8000 : 4000,
    });
  }, [ativo, mensagem, tipo]);
};

function ListagemFeedback(props) {
  const mostraErro = props.displayErro;
  const mensagemErro = props.mensagemErro;

  const mostraSucesso = props.displaySucesso;
  const mensagemSucesso = props.mensagemSucesso;

  const mostraAviso = props.displayAviso;
  const mensagemAviso = props.mensagemAviso;

  const mostraATPVe = props.displayATPVe;

  useToastFeedback(mostraErro, mensagemErro, "erro");
  useToastFeedback(mostraSucesso, mensagemSucesso, "sucesso");
  useToastFeedback(mostraAviso, mensagemAviso, "aviso");

  if (!mostraATPVe) {
    return null;
  }

  return (
    <div class="row row-padding-conteudo">
      <div class="col-12">
        <div class="alert alert-warning alert-w100" role="alert" style={{ lineHeight: "28px" }}>
          <span class="material-symbols-outlined" style={{ verticalAlign: "text-bottom" }}>warning</span>
          <strong>ATENÇÃO: </strong>
          Esse processo não é a comunicação de venda, mas sim o registro de intenção de venda.<br />
          O <strong>Registro de intenção de venda </strong>é a solicitação da Autorização para Transferência de Propriedade do Veículo Eletrônica (ATPV-e).<br />
          Para veículos com documento emitido a partir de 01/01/2021 é necessário solicitar a autorização antes de realizar o comunicado. <br />
          Esse processo substitui o preenchimento das informações no site do Detran-PR para solicitar o ATPV-e.<br />
          <strong>A intenção de venda e a comunicação de venda são atos distintos.</strong><br />
          <a href="https://www.detran.pr.gov.br/Noticia/Documento-de-transferencia-de-veiculos-agora-pode-ser-impresso-em-casa" target="_blank" rel="noreferrer">Saiba mais</a><br />
          <a href="https://www.detran.pr.gov.br/servicos/Veiculo/Compra-e-venda/Registrar-intencao-de-venda-do-veiculo-K03YMj34" target="_blank" rel="noreferrer">Saiba mais 2</a>
        </div>
      </div>
    </div>
  );
}

export default ListagemFeedback;
